module.exports = __webpack_public_path__ + "img/anquan2-1.d9431c7e.jpg";